module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/18_718fcbabb6a5b2e67134954a80e1e510.jpg";